/* Product page: options, photos, delivery or pick up date (cut off in Adelaide time), safe to leave,
   card message, add ons, and adding it all to the bag in one go. */
(function () {
  'use strict';
  function setup(root) {
    var B = window.BBC; if (!B || !root || root._p) return; root._p = 1;
    var $ = function (s) { return root.querySelector(s); }, $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };
    var jsonEl = root.parentNode.querySelector('[data-product-json]'); if (!jsonEl) return;
    var D; try { D = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    var form = $('[data-buy]'), addBtn = $('[data-add]'), errEl = $('[data-err]'), idSel = $('[data-id]');
    var pbar = root.parentNode.querySelector('[data-pbar]'), pbarBtn = pbar && pbar.querySelector('[data-pbar-btn]'), pbarPrice = pbar && pbar.querySelector('[data-pbar-price]');
    var current = D.variants.filter(function (v) { return idSel && String(v.id) === idSel.value; })[0] || D.variants[0];

    /* ---------- options ---------- */
    var groups = $$('[data-options] [data-oi]');
    function clean(v) { return String(v || '').replace(/\s*\(pictured\)\s*/i, '').replace(/^\$(\d+)\.00$/, '$$$1'); }
    function sel() { return groups.map(function (g) { var c = g.querySelector('input:checked'); return c ? c.value : null; }); }
    function match(o) { return D.variants.filter(function (v) { return v.o.every(function (x, i) { return x === o[i]; }); })[0]; }
    function paintOptions() {
      var s = sel();
      groups.forEach(function (g) {
        var oi = +g.getAttribute('data-oi');
        Array.prototype.forEach.call(g.querySelectorAll('.opt'), function (lab) {
          var inp = lab.querySelector('input'), trial = s.slice(); trial[oi] = inp.value;
          var m = match(trial), out = !m || !m.a, anyA = D.variants.some(function (x) { return x.o[oi] === inp.value && x.a; });
          lab.classList.toggle('is-out', out);
          var price = m ? B.money(m.p) : '', label = clean(inp.value);
          lab.querySelector('[data-small]').textContent = out ? (anyA ? 'Not in this combination' : 'Sold out') : ((oi === 0 || groups.length === 1) && price !== label ? price : '');
        });
        var val = root.querySelector('[data-val="' + oi + '"]'); if (val) val.textContent = clean(s[oi]);
      });
    }
    groups.forEach(function (g) {
      g.addEventListener('change', function (e) {
        var oi = +g.getAttribute('data-oi'), s = sel(), m = match(s);
        if (!m || !m.a) { // keep what they tapped, move the other options to something in stock
          var alt = D.variants.filter(function (v) { return v.o[oi] === s[oi] && v.a; })[0] || D.variants.filter(function (v) { return v.o[oi] === s[oi]; })[0];
          if (alt) { alt.o.forEach(function (x, i) { var r = groups[i] && groups[i].querySelector('input[value="' + CSS.escape(x) + '"]'); if (r) r.checked = true; }); m = alt; }
        }
        if (m) setVariant(m, true);
        if (e.target && e.target.focus) e.target.focus({ preventScroll: true });
      });
    });

    /* ---------- photos ---------- */
    var gal = $('[data-gal]');
    function mark(i) { $$('[data-dots] [data-i], [data-thumbs] [data-i]').forEach(function (b) { b.setAttribute('aria-current', +b.getAttribute('data-i') === i ? 'true' : 'false'); }); }
    function show(i, smooth) { if (!gal) return; var li = gal.children[i]; if (!li) return; gal.scrollTo({ left: li.offsetLeft, behavior: smooth ? 'smooth' : 'auto' }); mark(i); }
    if (gal) {
      var gt; gal.addEventListener('scroll', function () { clearTimeout(gt); gt = setTimeout(function () { mark(Math.round(gal.scrollLeft / (gal.clientWidth || 1))); }, 80); }, { passive: true });
      $$('[data-dots] [data-i], [data-thumbs] [data-i]').forEach(function (b) { b.addEventListener('click', function () { show(+b.getAttribute('data-i'), true); }); });
    }
    function mediaIndex(id) { if (!gal || !id) return -1; var kids = Array.prototype.slice.call(gal.children); for (var i = 0; i < kids.length; i++) if (+kids[i].getAttribute('data-media-id') === id) return i; return -1; }

    /* ---------- add ons ---------- */
    var addons = $$('[data-addon]');
    function addonTotal() {
      return addons.reduce(function (t, cb) { if (!cb.checked) return t; var item = cb.closest('.addon-item'), s = item.querySelector('select'); return t + (s ? +s.selectedOptions[0].getAttribute('data-price') : +cb.getAttribute('data-price')); }, 0);
    }
    addons.forEach(function (cb) {
      var item = cb.closest('.addon-item'), v = item.querySelector('[data-addon-var]'), s = v && v.querySelector('select');
      cb.addEventListener('change', function () { if (v) v.hidden = !cb.checked; paintButton(); });
      if (s) s.addEventListener('change', function () { item.querySelector('[data-addon-price]').textContent = '+' + B.money(+s.selectedOptions[0].getAttribute('data-price')); paintButton(); });
    });

    /* ---------- price and button ---------- */
    function paintButton() {
      var ok = current && current.a, total = (current ? current.p : 0) + addonTotal();
      if (addBtn) { addBtn.disabled = !ok; addBtn.innerHTML = ok ? 'Add to bag &middot; ' + B.money(total) : (current ? 'Sold out' : 'Choose an option'); }
      if (pbarPrice) pbarPrice.textContent = B.money(total);
      if (pbarBtn) pbarBtn.disabled = !ok;
    }
    function setVariant(v, moveImg) {
      current = v;
      if (idSel) idSel.value = v.id;
      var pr = $('[data-price]'), was = $('[data-was]');
      if (pr) pr.textContent = B.money(v.p);
      if (was) { was.hidden = !(v.cp > v.p); if (v.cp > v.p) was.textContent = B.money(v.cp); }
      paintOptions(); paintButton();
      if (moveImg) { var i = mediaIndex(v.m); if (i > -1) show(i, true); }
      try { history.replaceState(null, '', location.pathname + '?variant=' + v.id); } catch (e) { /* ignore */ }
    }

    /* ---------- delivery or pick up ---------- */
    var del = $('[data-delivery]');
    var st = { method: 'delivery', day: null, k: -1 };
    var nojsDate = root.querySelector('.nojs-only input[type="date"]'); if (nojsDate) nojsDate.disabled = true;
    // pick up times (Trinh, 23 Oct: the customer picks a time, two hours minimum): every half hour from opening to half an hour before closing; today starts pickupLead hours from now
    function slots(d, k) {
      var h = B.hoursFor(d.wd); if (!h) return [];
      var from = h[0], to = h[1] - 0.5, out = [];
      if (k === 0) { var t = B.adl(), e = Math.ceil((t.h + t.min / 60 + (+B.pickupLead || 2)) * 2) / 2; if (e > from) from = e; }
      for (var x = from; x <= to + 1e-6; x += 0.5) out.push(x);
      return out;
    }
    function canPick(d, k) { return B.canPickup(d, k) && slots(d, k).length > 0; }
    function options(method) {
      var out = [];
      for (var k = 0; k <= (+B.maxAhead || 60) && out.length < (+B.datesShown || 6); k++) {
        var d = B.dayAt(k), ok = method === 'pickup' ? canPick(d, k) : B.canDeliver(d, k);
        if (ok) out.push({ k: k, d: d, lab: B.label(d, k), sub: method === 'pickup' && k === 0 ? 'From ' + B.hr(slots(d, 0)[0]) : B.short(d) });
      }
      return out;
    }
    function paintDates() {
      if (!del) return;
      var post = st.method === 'post', dw = del.querySelector('[data-date-wrap]'), pn = del.querySelector('[data-post-note]'), cl = root.querySelector('.cut-line');
      if (dw) dw.hidden = post; if (pn) pn.hidden = !post; if (cl) cl.hidden = post;
      var opts = options(st.method), box = del.querySelector('[data-dates]');
      if (st.k < 0 || !opts.some(function (o) { return o.k === st.k; })) { if (!del._later) { st.k = opts.length ? opts[0].k : -1; st.day = opts.length ? opts[0].d : null; } }
      box.innerHTML = opts.map(function (o) {
        return '<button type="button" class="opt" role="radio" aria-checked="' + (o.k === st.k && !del._later) + '" data-k="' + o.k + '"><span><b>' + B.esc(o.lab) + '</b><small>' + B.esc(o.sub) + '</small></span></button>';
      }).join('');
      B.roving(del);
      var h = del.querySelector('[data-date-h]'); if (h) h.textContent = h.getAttribute(st.method === 'pickup' ? 'data-h-pickup' : 'data-h-delivery');
      var val = del.querySelector('[data-date-val]'); if (val) val.textContent = st.day ? B.long(st.day) : '';
      var sw = del.querySelector('[data-safe-wrap]'); if (sw) sw.hidden = st.method !== 'delivery';
      var later = del.querySelector('[data-later]');
      if (later) {
        later.min = B.dayAt(0).iso; later.max = B.dayAt(+B.maxAhead || 60).iso;
        // the box shows words: "Pick a date", or the date picked
        var lb = later.parentNode, lt = lb.querySelector('[data-later-txt]'), on = !!(later.value && del._later && st.day);
        if (lt) lt.textContent = on ? B.long(st.day).replace(/ \d{4}$/, '') : 'Pick a date';
        lb.classList.toggle('has-date', on);
      }
      paintTime();
    }
    // pick up time: a select laid over a box like the later date box, under the dates when Pick Up is chosen
    function paintTime() {
      var dw = del.querySelector('[data-date-wrap]'); if (!dw) return;
      var w = del.querySelector('[data-time-wrap]');
      if (!w) {
        var id = 'pt-' + Math.random().toString(36).slice(2, 8);
        w = document.createElement('div'); w.className = 'later'; w.setAttribute('data-time-wrap', '');
        w.innerHTML = '<label for="' + id + '">Pick up time</label><div class="later-box"><span data-time-txt>Choose a time</span>' +
          '<svg class="ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><circle cx="12" cy="12" r="8.5"/><path d="M12 7.5V12l3 2"/></svg>' +
          '<select id="' + id + '" data-time style="position:absolute;top:0;right:0;bottom:0;left:0;width:100%;height:100%;margin:0;padding:0;border:0;opacity:0;-webkit-appearance:none;appearance:none;font-size:16px;cursor:pointer"></select></div>';
        dw.appendChild(w);
        w.querySelector('select').addEventListener('change', function () { st.time = this.value ? +this.value : null; if (st.time != null) clearErr(); paintTime(); });
      }
      var on = st.method === 'pickup' && !!st.day, list = on ? slots(st.day, st.k) : [];
      w.hidden = !on || !list.length;
      if (st.time != null && list.indexOf(st.time) < 0) st.time = null;
      var sel = w.querySelector('select'), key = list.join(',');
      if (sel._key !== key) {
        sel._key = key;
        sel.innerHTML = '<option value="">Choose a time</option>' + list.map(function (x) { return '<option value="' + x + '">' + B.hr(x) + '</option>'; }).join('');
      }
      sel.value = st.time != null ? String(st.time) : '';
      var tt = w.querySelector('[data-time-txt]'); tt.textContent = st.time != null ? B.hr(st.time) : 'Choose a time';
      w.querySelector('.later-box').classList.toggle('has-date', st.time != null);
    }
    if (del) {
      var mbox = del.querySelector('[data-method]');
      if (mbox) mbox.addEventListener('click', function (e) {
        var b = e.target.closest('[role="radio"]'); if (!b) return; B.radio(mbox, b); st.method = b.getAttribute('data-m'); st.k = -1; del._later = false;
        var later = del.querySelector('[data-later]'); if (later) later.value = ''; clearErr(); paintDates();
      });
      del.querySelector('[data-dates]').addEventListener('click', function (e) {
        var b = e.target.closest('[data-k]'); if (!b) return; st.k = +b.getAttribute('data-k'); st.day = B.dayAt(st.k); del._later = false;
        var later = del.querySelector('[data-later]'); if (later) later.value = ''; clearErr(); paintDates();
        var f = del.querySelector('[data-k="' + st.k + '"]'); if (f) f.focus({ preventScroll: true });
      });
      var later = del.querySelector('[data-later]');
      // a click anywhere on the box opens the date picker (phones open it on the tap anyway)
      if (later) later.addEventListener('click', function () { try { if (later.showPicker) later.showPicker(); } catch (e) {} });
      if (later) later.addEventListener('change', function () {
        if (!later.value) { del._later = false; st.k = -1; paintDates(); return; }
        var p = later.value.split('-').map(Number), t = B.adl();
        var k = Math.round((Date.UTC(p[0], p[1] - 1, p[2]) - Date.UTC(t.y, t.m - 1, t.d)) / 864e5), d = B.dayAt(k);
        var ok = k >= 0 && k <= (+B.maxAhead || 60) && (st.method === 'pickup' ? canPick(d, k) : B.canDeliver(d, k));
        if (!ok) {
          del._later = false; st.k = -1; later.value = '';
          showErr(st.method === 'pickup' ? 'The studio is closed then. Please choose another pick up date.' : 'We do not deliver on that day. Please choose another date, delivery runs ' + deliveryDays() + '.');
          paintDates(); return;
        }
        clearErr(); del._later = true; st.k = k; st.day = d; paintDates();
      });
      var safe = del.querySelector('[data-safe]'), note = del.querySelector('[data-note]');
      if (safe && note) safe.addEventListener('change', function () { note.hidden = safe.checked; if (!safe.checked) note.focus(); });
      paintDates();
      setInterval(paintDates, 60000); // the cut off can pass while the page is open
    }
    function deliveryDays() {
      var d = (B.deliver || []).slice().sort(), names = d.map(function (x) { return B.DAY[x]; });
      if (d.length > 2 && d[d.length - 1] - d[0] === d.length - 1) return names[0] + ' to ' + names[names.length - 1];
      return names.join(', ');
    }

    /* ---------- card message and gift cards ---------- */
    $$('[data-msg]').forEach(function (m) {
      var c = m.parentNode.querySelector('[data-count]'), max = m.getAttribute('maxlength');
      m.addEventListener('input', function () { if (c) c.textContent = m.value.length + '/' + max; });
    });
    var gcT = $('[data-gc-toggle]'), gcF = $('[data-gc-fields]');
    if (gcT && gcF) gcT.addEventListener('change', function () {
      gcF.hidden = !gcT.checked;
      Array.prototype.forEach.call(gcF.querySelectorAll('input,textarea'), function (x) { x.disabled = !gcT.checked; });
      var sendOn = gcF.querySelector('input[type="date"]'); if (sendOn) { sendOn.min = B.dayAt(0).iso; sendOn.max = B.dayAt(90).iso; }
    });

    /* ---------- add to bag ---------- */
    function showErr(msg) { if (errEl) { errEl.textContent = msg; } }
    function clearErr() { if (errEl) errEl.textContent = ''; }
    function properties() {
      var p = {};
      if (del) {
        if (st.method === 'post') {
          p['Delivery method'] = 'Post';
        } else if (st.method === 'pickup') {
          p['Delivery method'] = 'Pick up in store';
          p['Pick up date'] = B.long(st.day) + (st.time != null ? ' at ' + B.hr(st.time) : '');
        } else {
          p['Delivery method'] = D.kind === 'pack' ? 'Delivery, first of the pack' : 'Delivery';
          p['Delivery date'] = B.long(st.day);
          var safe = del.querySelector('[data-safe]'), note = del.querySelector('[data-note]');
          p['Leave if no one is home'] = safe && safe.checked ? 'Yes' : 'No';
          if (safe && !safe.checked && note && note.value.trim()) p['Delivery instructions'] = note.value.trim();
        }
        if (st.method !== 'post') p._date = st.day.iso;
      }
      var msg = form.querySelector('textarea[name="properties[Card message]"]');
      if (msg && msg.value.trim()) p['Card message'] = msg.value.trim();
      // Special days (24 Oct 2026): any field marked data-xp="<property name>" rides on the line, ticked boxes as Yes
      Array.prototype.forEach.call(form.querySelectorAll('[data-xp]'), function (x) { var k = x.getAttribute('data-xp'); if (x.type === 'checkbox') { if (x.checked) p[k] = 'Yes'; } else if (x.value) p[k] = x.value; });
      if (gcT && gcT.checked) {
        p.__shopify_send_gift_card_to_recipient = 'on';
        Array.prototype.forEach.call(gcF.querySelectorAll('[name^="properties["]'), function (x) { var k = x.name.slice(11, -1); if (x.value.trim()) p[k] = x.value.trim(); });
      }
      return p;
    }
    form.addEventListener('submit', function (e) {
      e.preventDefault(); clearErr();
      if (!current || !current.a) return;
      if (del && st.method !== 'post' && !st.day) { showErr('Please choose a ' + (st.method === 'pickup' ? 'pick up' : 'delivery') + ' date.'); del.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      if (del && st.method === 'pickup' && st.time == null) { showErr('Please choose a pick up time.'); var tw = del.querySelector('[data-time-wrap]'); if (tw && !tw.hidden) tw.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      if (gcT && gcT.checked) { var em = gcF.querySelector('input[type="email"]'); if (!em.value.trim() || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(em.value.trim())) { showErr('Please add their email address.'); em.focus(); return; } }
      var items = [{ id: current.id, quantity: 1, properties: properties() }];
      addons.forEach(function (cb) {
        if (!cb.checked) return; var s = cb.closest('.addon-item').querySelector('select');
        items.push({ id: +(s ? s.value : cb.value), quantity: 1, properties: { With: D.title } });
      });
      addBtn.disabled = true; var label = addBtn.innerHTML; addBtn.textContent = 'Adding';
      B.addToCart(items).then(function () {
        addBtn.textContent = 'Added';
        B.toast(D.title + (items.length > 1 ? ' and ' + (items.length - 1) + ' extra' + (items.length > 2 ? 's' : '') : '') + ' added', true);
        addons.forEach(function (cb) { cb.checked = false; var v = cb.closest('.addon-item').querySelector('[data-addon-var]'); if (v) v.hidden = true; });
        setTimeout(function () { addBtn.disabled = false; paintButton(); }, 1200);
      }).catch(function (err) {
        addBtn.disabled = false; addBtn.innerHTML = label;
        showErr(err && err.message ? err.message : 'Something went wrong. Please try again.');
        if (errEl) errEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });
    if (pbarBtn) pbarBtn.addEventListener('click', function () { if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true })); });
    if (pbar && addBtn) B.stickyAfter(addBtn, pbar);

    paintOptions(); paintButton();
  }
  function all() { Array.prototype.forEach.call(document.querySelectorAll('[data-pdp]'), setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', all);
})();
